<template>
  <div class="content">
    <msg-menu></msg-menu>

    <div class="tabs messages-tabs-content">
      <div id="tab-templates" class="tab active clearfix">
        <div class="d-block d-block-msg shadow-md d-block-msg-templates template-list-wrap">
          <!--div class="coming-soon">
              <img src="images/templates.svg" alt="templates">
              <div>Templates Coming Soon</div>
              <p class="info">We will let you know when this feature is available</p>
          </div-->

          <div class="msg-title">
            <div class="row">
              <div class="col-sm-3">
                <h1>Message Templates</h1>
              </div>
              <div class="col-sm-9 text-right">
                <div class="search search-templates">
                  <input class="input-sm search-template-input" v-model="templatesFilter" type="text"
                         placeholder="Search templates">
                </div>
                <router-link :to="{name: 'templatesNew'}" class="btn btn-sm create-template-btn">
                  <span class="plus-icon plus-icon-black"></span> Create a Template
                </router-link>
              </div>
            </div>
          </div>
          <div class="template-wrap clearfix">
            <div class="left-column">
              <div class="heading">Template Folders</div>
              <div class="template-theme templates-folder-list" data-show-all="1">
                <a v-for="(folder, index) in folders"
                   :key="index"
                   href="#"
                   v-on:click.prevent="selectFolder(folder)"
                   class="item" :class="{active: folder.id == activeFolder.id}"
                >{{folder.name}}<span class="unread-count">{{folder.template_count}}</span>
                </a>
              </div>
              <div class="msg-footer">
                <a href="#" v-on:click.prevent="isNewFolderModal = true" class="new-templates-folder add-folder-btn">
                  <img class="inline-block" :src="require('../../assets/icons/plus-grey.png')" alt="">Add Folder</a>
              </div>
            </div>
            <div class="column container-fluid">
              <div class="heading row">
                <div class="col-sm-6">Templates</div>
                <div class="col-sm-6 text-right attachment-header-title">Attachment</div>
              </div>
              <div class="msg-template-content">
                <div v-for="(template, index) in templatesArray"
                     :key="index"
                     class="msg-template-item clearfix"
                     :class="{active: activeTemplate && activeTemplate.id == template.id}"
                     v-on:click.prevent="selectTemplate(template)"
                >
                  <div v-if="template.attachmentInfo && template.attachmentInfo.type!='none'" class="attachment-wrap">
                    <attachment
                        :attachment-info="template.attachmentInfo"
                        :charity-info="activeCharityInfo"
                    ></attachment>
                  </div>

                  <div class="template-title">{{template.name}}</div>
                  <p class="template-body">{{template.msgText}}</p>
                </div>
              </div>
              <div class="msg-footer row">
                <div v-if="activeTemplate" class="template-actions ">
                  <div class="col-sm-3">
                    <a href="#"
                       v-on:click.prevent="deleteActiveTemplate"
                       class="btn btn-sm btn-delete delete-template-btn">Delete</a>
                  </div>
                  <div class="col-sm-9 text-right">
                    <a href="#"
                       v-on:click.prevent="$router.push({name: 'templatesEdit', params: {templateId: activeTemplate.id}})"
                       class="btn btn-sm btn-edit edit-template-btn">Edit Template
                    </a>
                    <a href="#"
                       v-on:click.prevent="$router.push({name: 'messagesNew', query: {template_id: activeTemplate.id}})"
                       class="btn btn-sm use-template-btn">
                      Use Template
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="isNewFolderModal"
           v-on:close-modal="isNewFolderModal = false"
           v-on:done="updateFolders(); isNewFolderModal=false"
           :modal-name="'new-templates-folder'"></modal>

  </div>
</template>

<script>
  import {getFolders, deleteTemplate} from '@/utils/api';
  import templatesMixin from './templates-mixin';
  import Modal from '../Modal/index.vue';
  import MsgMenu from './menu.vue';
  import Attachment from './attachment.vue';
  import {mapState} from "vuex";

  export default {
    name: 'Templates',
    metaInfo: {
      title: 'Templates',
    },
    mounted() {
      this.updateFolders();
    },
    components: {
      MsgMenu,
      Attachment,
      Modal,
    },
    mixins: [templatesMixin],
    methods: {
      updateFolders: function() {
        getFolders().then(folders => {
          this.initFolders(folders);
        });
      },
      deleteActiveTemplate: function() {
        if (this.activeTemplate) {

          deleteTemplate(this.activeTemplate.id).then(() => {
            this.updateFolders();
            this.templates = this.templates.filter(template => this.activeTemplate.id !== template.id);
            this.activeTemplate = false;
          });
          //this.activeTemplate
        }
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
    },
    watch: {
      'activeCharityId'() {
        this.activeTemplate = false;
        this.activeFolder = false;
        this.folders = [];
        this.templates = [];

        this.updateFolders();
      },
    },
    data() {
      return {
        isNewFolderModal: false,
        folders: [],
      };
    },
  };
</script>
<style lang="sass">
  .messages-tabs-content
    .template-body
      white-space: pre-wrap
    .edit-template-btn, .use-template-btn
      font-size: 13px
      vertical-align: top
</style>
